import { render } from "./PersonalRecordView.vue?vue&type=template&id=3ed5fadc"
import script from "./PersonalRecordView.vue?vue&type=script&lang=js"
export * from "./PersonalRecordView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__